<template>
    <div class="rd">
        <div class="pagina">
            <div class="inlog-wrap">
                <div class="leeg"><h2>Authenticating…</h2></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Message } from "element-ui";
import { onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router/composables';
import { exchangeCodeForToken } from "../../api/rest";

const router = useRouter();
const route = useRoute();

onMounted(async () => {
    const { code } = route.params;

    try {
        const token = await exchangeCodeForToken(code);
        localStorage.setItem('xcube-session-key', token);
        router.push('/bookings');
    } catch (error) {
        if (error.message === "link.expired") {
            Message({
                message: "The login link has expired. Please request a new one.",
                type: "error",
                plain: true,
            });
            router.push('/login');
        } else {
            Message({
                message: "The login link is invalid. Please request a new one.",
                type: "error",
                plain: true,
            });
            router.push('/login');
        }
    }
});
</script>
